export type ValidationHeaderStatusTone = 'ready' | 'missing' | 'blocked';
export type ValidationHeaderStatusColor = 'success' | 'error' | 'warning';
export type ValidationHeaderStatusIcon = 'success' | 'critical' | 'error' | 'warning';

export interface ValidationHeaderStatusInput {
  criticalCount: number;
  errorCount: number;
  warningCount: number;
  unresolvedFamilyCount: number;
}

export interface ValidationHeaderStatusSummary {
  label: string;
  tone: ValidationHeaderStatusTone;
  color: ValidationHeaderStatusColor;
  icon: ValidationHeaderStatusIcon;
  isClear: boolean;
}

export function resolveValidationHeaderStatus({
  criticalCount,
  errorCount,
  warningCount,
  unresolvedFamilyCount,
}: ValidationHeaderStatusInput): ValidationHeaderStatusSummary {
  if (criticalCount > 0) {
    return {
      label: `${criticalCount} Critical`,
      tone: 'missing',
      color: 'error',
      icon: 'critical',
      isClear: false,
    };
  }

  if (errorCount > 0) {
    return {
      label: `${errorCount} Errors`,
      tone: 'missing',
      color: 'error',
      icon: 'error',
      isClear: false,
    };
  }

  if (warningCount > 0) {
    return {
      label: `${warningCount} Warnings`,
      tone: 'blocked',
      color: 'warning',
      icon: 'warning',
      isClear: false,
    };
  }

  if (unresolvedFamilyCount > 0) {
    return {
      label: `${unresolvedFamilyCount} Issues`,
      tone: 'blocked',
      color: 'warning',
      icon: 'warning',
      isClear: false,
    };
  }

  return {
    label: 'All clear',
    tone: 'ready',
    color: 'success',
    icon: 'success',
    isClear: true,
  };
}
